const loadingLabel = "Cargando";
const esPE = {
  loadingLabel
};
export {
  esPE as default,
  loadingLabel
};
